import { getAudioContext } from './sharedAudio';
import he1 from './fillers/he-1.mp3'; import he2 from './fillers/he-2.mp3'; import he3 from './fillers/he-3.mp3'; import he4 from './fillers/he-4.mp3';
import ar1 from './fillers/ar-1.mp3'; import ar2 from './fillers/ar-2.mp3'; import ar3 from './fillers/ar-3.mp3'; import ar4 from './fillers/ar-4.mp3';
import en1 from './fillers/en-1.mp3'; import en2 from './fillers/en-2.mp3'; import en3 from './fillers/en-3.mp3'; import en4 from './fillers/en-4.mp3';

/**
 * FILLERS ONLY ON SLOW TURNS. Four short pre-rendered clips per language ("רגע, בודקת…", "لحظة، عم شوف…", "One moment…"),
 * made once with Luna's own voice (scripts/render-voice-fillers.js) and committed. They are never generated live and never
 * in the wrong language: play(lang) knows only he / ar / en and does nothing for anything else. They rotate, and stop() cuts
 * one with a 40 ms fade the instant the real answer's sound starts.
 */
export const FILLER_FILES = { he: [he1, he2, he3, he4], ar: [ar1, ar2, ar3, ar4], en: [en1, en2, en3, en4] };
export const FILLER_DELAY_MS = 900; // no sound this long after the person stopped: a slow turn
export const FILLER_AGAIN_MS = 8_000; // a turn that is STILL silent this long after a filler began gets the next one (28 Oct: a 34 s turn had one 'one moment' and 32 s of nothing)
export const MAX_FILLERS = 3;

const defaultLoad = async (url) => (await fetch(url)).arrayBuffer();

export function createFillers({ getContext = getAudioContext, load = defaultLoad, files = FILLER_FILES, random = Math.random } = {}) {
  const loading = {}; // lang -> Promise
  const ready = {}; // lang -> AudioBuffer[] once decoded (play must be synchronous: a filler never makes the answer wait)
  const turn = {}; // lang -> next index (rotation)

  /** Loads and decodes a language's clips (ahead of need: voice mode start, and the language of the turn that just began). */
  function prepare(lang) {
    const list = files[lang];
    const ctx = getContext();
    if (!list || !ctx) return Promise.resolve([]);
    if (!loading[lang]) {
      loading[lang] = Promise.all(list.map(async (u) => { try { return await ctx.decodeAudioData(await load(u)); } catch (_) { return null; } }))
        .then((a) => { ready[lang] = a.filter(Boolean); return ready[lang]; });
    }
    return loading[lang];
  }

  /** Plays the next filler of `lang` now, or returns null (a language it has none for, or clips not decoded yet). */
  function play(lang) {
    const ctx = getContext();
    if (!files[lang] || !ctx) return null;
    if (!ready[lang]) { prepare(lang); return null; }
    const list = ready[lang];
    if (!list.length) return null;
    if (turn[lang] == null) turn[lang] = Math.floor(random() * list.length);
    const buffer = list[turn[lang]++ % list.length];
    const src = ctx.createBufferSource();
    const gain = ctx.createGain();
    src.buffer = buffer;
    src.connect(gain); gain.connect(ctx.destination);
    src.start();
    return {
      stop() {
        try { gain.gain.setValueAtTime(gain.gain.value, ctx.currentTime); gain.gain.linearRampToValueAtTime(0, ctx.currentTime + 0.04); src.stop(ctx.currentTime + 0.05); } catch (_) { /* already over */ }
      },
    };
  }
  return { prepare, play };
}
